import React from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "./colors";
import Card from "./Card";

/** The page's shape while its data loads. */
export default function Skeleton() {
    return (
        <Stack aria-busy="true" aria-label="Loading dashboard">
            <Block style={{ height: 76 }} />
            <Card as="div">
                <Pad>
                    <Block style={{ height: 16, width: 192 }} />
                    <Block style={{ height: 12, width: 256, marginTop: 8 }} />
                </Pad>
                <Tiles>
                    {[0, 1, 2, 3].map((i) => (
                        <Pad key={i}>
                            <Block style={{ height: 12, width: 64 }} />
                            <Block style={{ height: 24, width: 96, marginTop: 8 }} />
                        </Pad>
                    ))}
                </Tiles>
                <Block style={{ height: 300, margin: 20, background: colors.canvas }} />
            </Card>
            <Block style={{ height: 360 }} />
        </Stack>
    );
}

const pulse = keyframes`50% { opacity: 0.5; }`;

const Stack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const Block = styled.div`
    border-radius: 8px;
    background: ${colors.line}99;
    animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

const Pad = styled.div`
    padding: 16px 20px;
`;

const Tiles = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-top: 1px solid ${colors.line};
    border-bottom: 1px solid ${colors.line};
`;
